// src/Services/PinnacleService.js

import { CommonDataService, getcommentStr } from './CommonDataService';
import { PINNCALE_LOG_OBJ } from '../constants/commonJsonConstants';
import { getCurrentTimestamp } from './CommonDataService';

/**
 * Shared Pinnacle logging utility to eliminate duplicate code
 * across NewAssignment, CancelAssignment, and HoldAssignment components.
 *
 * @param {Object} accountInformation  - Account details object
 * @param {Object} contractorInfoForComment - Contractor info for comment generation
 * @param {Object} userInfo - User session info containing userid
 * @param {string} actNotes - Action notes constant (e.g., Constants.ACTION_CANCEL)
 * @param {string} actCode  - Action code constant  (e.g., Constants.rsCANCEL_CONFIRM)
 * @returns {Promise|null} - Returns createPinnacleContact promise or null
 */
export const logPinnacleContact = async (
  accountInformation,
  contractorInfoForComment,
  userInfo,
  actNotes,
  actCode
) => {
  // Step 1: Build the base PINNACLE_LOG_OBJ with common properties
  const pinnacleLogObj = {
    ...PINNCALE_LOG_OBJ,
    receivableAccountNumber: accountInformation.custAcctNb,
    coBusCd: accountInformation.coBusCd,
    createdTimeStamp: getCurrentTimestamp(),
    enteredBranchCode: accountInformation.superBranchCd,
    createdBy: 'FCREPO',
  };

  // Step 2: Defensive check for userInfo and its userid property
  if (!userInfo?.userid) {
    console.warn(
      'logPinnacleContact: userInfo or userInfo.userid is missing. Skipping createPinnacleContact call.'
    );
    return null;
  }

  // Step 3: Generate the comment string
  let commentValue;
  try {
    commentValue = getcommentStr(
      contractorInfoForComment,
      actNotes,
      actCode,
      userInfo.userid
    );
  } catch (error) {
    console.error(
      'logPinnacleContact: Error calling getcommentStr:',
      error
    );
    return null;
  }

  console.log(
    'logPinnacleContact: Comment String:',
    commentValue
  );

  // Step 4: Check if commentValue is null or undefined before proceeding
  if (commentValue == null) {
    console.warn(
      'logPinnacleContact: Comment string is null or undefined. Skipping createPinnacleContact call.'
    );
    return null;
  }

  // Step 5: Assign the valid comment to the log object
  pinnacleLogObj.comment = commentValue;

  console.log(
    'logPinnacleContact: PINNACLE_LOG_OBJ after comment set:',
    pinnacleLogObj
  );

  // Step 6: Call createPinnacleContact only if comment is valid
  console.log(
    'logPinnacleContact: comment is not null. Calling CommonDataService.createPinnacleContact.'
  );
  return CommonDataService.createPinnacleContact(pinnacleLogObj);
};
